const cookieDomain = process.env.REACT_APP_COGNITO_COOKIE_DOMAIN || "";
const cognitoRegion = process.env.REACT_APP_COGNITO_REGION || "";
const cognitoUserPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID || "";
const cognitoUserPoolClientId =
  process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID || "";
const cognitoDomain = process.env.REACT_APP_COGNITO_USER_POOL_AUTH_DOMAIN || "";
const redirectUri = window.location.origin;

export interface AmplifyConfig {
  Auth: {
    region: string;
    userPoolId: string;
    userPoolWebClientId: string;
    cookieStorage: {
      domain: string;
    };
    oauth: {
      domain: string;
      scope: string[];
      redirectSignIn: string;
      redirectSignOut: string;
      responseType: string;
    };
  };
}

export const amplifyConfig: AmplifyConfig = {
  Auth: {
    region: cognitoRegion,
    userPoolId: cognitoUserPoolId,
    userPoolWebClientId: cognitoUserPoolClientId,
    cookieStorage: {
      domain: cookieDomain,
    },
    oauth: {
      domain: cognitoDomain,
      scope: ["email", "openid", "profile"],
      redirectSignIn: redirectUri,
      redirectSignOut: redirectUri,
      responseType: "code",
    },
  },
};
